var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pageLoader)?_c('div',{class:`page-loader ${_vm.themeSelected}`},[_c('img',{attrs:{"src":_vm.siteLogo,"alt":_vm.websiteName,"data-aos":"zoom-in"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }